// deps
import React, { memo, ReactElement, ReactNode } from "react";
import cx from "classnames";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

//styles
import styles from "./LinkAccountContent.scss";

interface LinkContentProps {
    renderHeader?: () => ReactNode;
    renderContent?: () => ReactNode;
    primaryAction: {
        text: string;
        onClick: VoidFunction;
    };
    secondaryAction?: {
        text: string;
        onClick: VoidFunction;
    };
    containerClass?: string;
}

function LinkContent(props: LinkContentProps): ReactElement {
    const { renderHeader, renderContent, primaryAction, secondaryAction } = props;

    const primaryButtonClassname = cx({
        [styles.primaryBtnBottomFixed]: !secondaryAction,
    });
    return (
        <div className={cx(styles.container, props.containerClass)}>
            <div className={styles.header}>{renderHeader && renderHeader()}</div>
            <div className={styles.content}>{renderContent && renderContent()}</div>
            <SuperButton
                variant="fullwidth"
                buttonType="primary"
                buttonSize="large"
                onClick={primaryAction.onClick}
                className={primaryButtonClassname}
            >
                {primaryAction.text}
            </SuperButton>

            {secondaryAction && (
                <SuperButton
                    variant="fullwidth"
                    buttonType="secondary"
                    buttonSize="large"
                    onClick={secondaryAction.onClick}
                    className={styles.secondaryBtn}
                >
                    <span>{secondaryAction.text}</span>
                </SuperButton>
            )}
        </div>
    );
}

export default memo(LinkContent);
